/**
  handle communication with back end
  add bearer token to request
*/

import axios from 'axios'

export default class ZComm {

    header() {
        return {
            headers: {
                'Authorization': `Bearer ${this.app.$page.props.auth.user.token}`,
                'Accept' : 'application/json',
                'authorizationHeader': `${this.app.$page.props.auth.user.sso_id}`
            }
        }
    }

    clearmessage(){
      // TODO
    }

    /**
     * use with "store" route only
     * to add new entity in database. e.g.: new profile, new ks, new ott
     * @param {*} url
     * @param {*} data (from data)
     */
    add(url, data) {
        this.clearmessage()
        return new Promise((resolve, reject) => {
            axios.post(this.app.$route(url), data, this.header())
                .then(res => {
                    // console.log(res)
                    this.app.$page.props.flash.success = "Rekod telah berjaya ditambah"
                    resolve(res.data)
                })
                .catch(err => {
                    this.app.$page.props.flash.error = "Terdapat ralat di dalam memproses input anda. " + err.response.data.message
                    this.app.$page.props.errors = err.response.data.errors
                    reject(err)
                })
        })
    }

    /**
     * use with "update" route only
     * @param {*} url (the update url)
     * @param {*} id (the model primary key)
     * @param {*} data (the form data)
     */
    update(url, id, data) {
        // this.clearmessage()
        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url, id)
          // alert(url)
        }

        return new Promise((resolve, reject) => {
            axios.put(url, data, this.header())
                .then(res => {
                    // console.log(res)
                    this.app.$zutil.notify ("Rekod telah berjaya dikemaskini")
                    resolve(res.data)
                })
                // .catch(err => {
                //     // console.log(err.response.data)
                //     this.app.$zutil.notify("Terdapat ralat di dalam memproses input anda. " + err.response.data.message, false)
                //     this.app.$page.props.errors = err.response.data.errors
                //     reject(err)
                // })
        })

    }

    updateNoNotif(url, id, data) {
        // this.clearmessage()
        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url, id)
          // alert(url)
        }

        return new Promise((resolve, reject) => {
            axios.put(url, data, this.header())
                .then(res => {
                    // console.log(res)
                    // this.app.$zutil.notify ("Rekod telah berjaya dikemaskini")
                    if (!options.silent) {
                        this.app.$zutil.notify("Rekod telah berjaya dikemaskini")
                    }

                    resolve(res.data)
                })
                // .catch(err => {
                //     // console.log(err.response.data)
                //     this.app.$zutil.notify("Terdapat ralat di dalam memproses input anda. " + err.response.data.message, false)
                //     this.app.$page.props.errors = err.response.data.errors
                //     reject(err)
                // })
        })

    }

    /**
     * delete resource/entity
     * @param {*} url
     * @param {*} id
     */

     batal(url, id, data) {
        // this.clearmessage()
        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url, id)
          // alert(url)
        }

        return new Promise((resolve, reject) => {
            axios.put(url, data, this.header())
                .then(res => {
                    // console.log(res)
                     this.app.$zutil.notify ("Permohonan Di Tolak !", false);
                    resolve(res.data)
                })
                // .catch(err => {
                //     // console.log(err.response.data)
                //     this.app.$zutil.notify("Terdapat ralat di dalam memproses input anda. " + err.response.data.message, false)
                //     this.app.$page.props.errors = err.response.data.errors
                //     reject(err)
                // })
        })

    }

    delete(url, id) {
        this.clearmessage()
        return new Promise((resolve, reject) => {
            axios.delete(this.app.$route(url, id), this.header())
                .then(res => {
                    this.app.$page.props.flash.error = "Rekod telah berjaya dipadam"
                    resolve(res.data)
                })
                .catch(err => {
                  this.app.$page.props.flash.error = "Terdapat ralat di dalam memproses input anda. " + err.response.data.message
                  this.app.$page.props.errors = err.response.data.errors
                  reject(err)
                })

        })
    }

    // post expects callee to handle the message
    post(url, data, header) {
        // this.clearmessage()
        // console.log(url)

        let headers = {
            headers: Object.assign(this.header().headers, header)
        };

        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url)
        }

        return new Promise((resolve, reject) => {
            axios.post(url, data, headers)
                .then(res => {
                    // console.log(res)
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    // patch expects callee to handle the message
    patch(url, id, data, header) {
      this.clearmessage()

        let headers = {
            headers: Object.assign(this.header().headers, header)
        };

      return new Promise((resolve, reject) => {
          axios.patch(this.app.$route(url, id), data, headers)
              .then(res => {
                  resolve(res.data)
              })
              .catch(err => {
                  reject(err)
              })
      })
    }

    // get expects callee to handle the message
    get(url, data) {
      // this.clearmessage()
      return new Promise((resolve, reject) => {
        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url)
        }
        data.api =  this.app.$page.props.auth.user.token
        axios.get(url, {params: data,  headers: {
                'Authorization': `Bearer ${this.app.$page.props.auth.user.token}`,
                'Accept' : 'application/json',
                'authorizationHeader': `${this.app.$page.props.auth.user.sso_id}`
            }})
          .then(res => {
            // console.log(res)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    }

    // find expects callee to handle the message
    find(url, id, data) {
      this.clearmessage()
      return new Promise((resolve, reject) => {
        axios.get(this.app.$route(url, id), this.header())
          .then(res => {
            // console.log(res)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    }

    async lookup(url, data = {}) {
        this.clearmessage()
        if(!this.isValidHttpUrl(url))
        {
          url = this.app.$route(url)
        }
        data.api =  this.app.$page.props.auth.user.token
        const response = await axios.post(url, data, this.header());
        const datas = await response.data;
        return datas;

    }

    isValidHttpUrl(string) {
      let url;

      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    }

}

